import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
import { putData } from "../../../utils/api";
import { Select2Data } from "../../../utils/common";
import { getData } from "../../../utils/api";
import Select from "react-select";
import { Controller } from "react-hook-form";

library.add(fas);

const EditOffCanvance = (props) => {
    const id = props.show;
    const { postData, getData, IMG_URL } = useContext(Context);
    const [showModal, setShowModal] = useState({
        code: 0,
        message: "",
    });

    // const GetEditData = async () => {
    //     const response = await getData(`/admin/masters/product-reviews/${id}`);
    //     console.log(response ,"data for review ")
    //     reset(response?.data);
    // };

const [editData, setEditData] = useState(null);
const [productreviews, setProductreviews] = useState([]);



    const {
        control,
        register,
        handleSubmit,
        
        formState: { errors },
        reset,
        getValues,
        watch,
    } = useForm();

    const imageFile = watch("image");

      
        const [ratingProducts, setRatingProducts] = useState([]);
        const loadRatingProducts = async () => {
            const res = await getData("/admin/masters/product-ratings");
            if (res?.success) setRatingProducts(res.data);
        };
    
        useEffect(() => {
            loadRatingProducts();
        }, []);
    
    const ratingArray = ratingProducts?.data || [];
    
    const productDropdown = ratingArray.map((rp) => ({
        label: rp?.Product?.name,
        value: rp?.id,          // this is product_rating_id
        product_id: rp?.product_id,
        product_rating_id: rp?.id
    }));

   const onSubmit = async (data) => {
  
    try {
        const finalData = new FormData();     
        const selected = productDropdown.find(
            (item) => item.value === data.product_rating_id?.value
        );
        if (!selected) {
            return;
        }
        // Save product_rating_id (value)
         finalData.append("product_rating_id", data.product_rating_id?.value);
        finalData.append("name", data?.name);
        finalData.append("description", data?.description);
        finalData.append("image", data?.image?.[0]);
        finalData.append("alt_tag", data?.alt_tag?.trim() || "");

        const response = await putData(`/admin/masters/product-reviews/${id}`, finalData);
        if (response?.success) {
        await setShowModal({ code: response?.code, message: response?.message });
        } else {
            await setShowModal({ code: response?.code, message: response?.message });
        }
        
       setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);

      

    } catch (error) {
    }
};

    const [imagePreview, setImagePreview] = useState(null); // State to store image preview

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImagePreview(reader.result); // Set image preview
            };
            reader.readAsDataURL(file);
        }
    };

const GetEditData = async () => {
    const response = await getData(`/admin/masters/product-reviews/${id}`);
    setEditData(response?.data);
};

const [isDataLoaded, setIsDataLoaded] = useState(false);

useEffect(() => {
    if (editData && productDropdown?.length > 0 && !isDataLoaded) {
        const selectedOption = productDropdown.find(
            (item) => item.value === editData.product_rating_id
        );

        reset({
            ...editData,
            product_rating_id: selectedOption || null,
        });
        setIsDataLoaded(true);
    }
}, [editData, productDropdown, reset, isDataLoaded]);

  
    useEffect(() => {
        GetEditData();
    }, []);    




    return (
        <>
            <Modal
                {...props}
                onHide={props.handleClose}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Product Review
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
                        <Row className="">

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Group>
                                        <Form.Label>Product</Form.Label>

                                        <InputGroup>
                                            <Controller
                                                name="product_rating_id"
                                                control={control}
                                                rules={{ required: "Please select a product" }}
                                                render={({ field }) => (
                                                    <Select
                                                        options={productDropdown || []}
                                                        onChange={(val)=> field.onChange(val)}
                                                        // value={productreviews.find(opt => opt.value === field.value?.value)}
                                                         value={field.value} 
                                                        placeholder="Select Product"
                                                    />
                                                )}
                                            />
                                        </InputGroup>

                                        {errors.product_rating_id && (
                                            <span className="text-danger">
                                                {errors.product_rating_id.message}
                                            </span>
                                        )}
                                    </Form.Group>
                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="main-form-section mt-3">
                                    <Row className="justify-content-center">
                                        <Form.Group>
                                            <Form.Label>Product Review</Form.Label>

                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    placeholder="Name"
                                                    className={classNames("", {
                                                        "is-invalid": errors?.name,
                                                    })}
                                                    {...register("name", {
                                                        required: "Name Is Required",
                                                        validate: (value) =>
                                                            value.length <= 200 ||
                                                            "Data must be 200 characters or less",
                                                    })}
                                                />
                                            </InputGroup>
                                            {errors.name && (
                                                <span className="text-danger">
                                                    {errors.name.message}
                                                </span>
                                            )}
                                        </Form.Group>
                                    </Row>
                                </div>

                                <Col md={6}>
                                    <div className="main-form-section mt-3">
                                        <Form.Group>
                                            <div className="">
                                                <Form.Label>Description</Form.Label>
                                            </div>
                                            <InputGroup>
                                                <Form.Control
                                                    type="text"
                                                    name="description"
                                                    placeholder="description"
                                                    className={classNames("", {
                                                        "is-invalid": errors?.description,
                                                    })}
                                                    {...register("description", {
                                                        required: "description is required",
                                                        validate: (value) =>
                                                            value.length <= 200 ||
                                                            "Data must be 200 characters or less",
                                                    })}
                                                />
                                            </InputGroup>
                                            {errors.description && (
                                                <span className="text-danger">{errors?.description?.message}</span>
                                            )}
                                        </Form.Group>
                                    </div>
                                </Col>

                                <div className="main-form-section mt-3">
                                    <Row className="justify-content-start">
                                        <Form.Label className="text-left">Image</Form.Label>

                                        <Form.Group>
                                            <Form.Control
                                                className={classNames("", {
                                                    "is-invalid": errors?.image,
                                                })}
                                                type="file"
                                                {...register("image", {
                                                    // validate: async (value) => {
                                                    //   if (typeof value !== "string") {
                                                    //     const fileTypes = ["jpg", "png", "jpeg", "webp"];
                                                    //     const fileType = value[0].name?.split(".")[1];
                                                    //     if (!fileTypes.includes(fileType)) {
                                                    //       return `please upload a valid file format. (${fileTypes})`;
                                                    //     }
                                                    //     const sizes = await getDimension(value[0]);
                                                    //     if (
                                                    //       sizes.width !== 420 &&
                                                    //       sizes.height !== 520
                                                    //     ) {
                                                    //       return "Image width and height must be 420 px and 520 px";
                                                    //     }
                                                    //     const fileSize = Math.round(
                                                    //       value[0].size / 1024
                                                    //     );
                                                    //     if (fileSize > 500) {
                                                    //       return "file size must be lower than 500kb";
                                                    //     }
                                                    //   }
                                                    // },
                                                })}
                                                accept=".jpg, .jpeg, .png"
                                            />
                                        </Form.Group>
                                        {errors.image && (
                                            <span className="text-danger">
                                                {errors.image.message}
                                            </span>
                                        )}
                                        <Form.Group className="mt-3">
                                            <Form.Label className="text-left">Alt Tag</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="alt_tag"
                                                placeholder="Alt Tag"
                                                {...register("alt_tag")}
                                            />
                                        </Form.Group>
                                    </Row>
                                </div>
                            </Col>

                            <Col lg={6}>
                                <div className="main-form-section mt-3">
                                    <Form.Label>Image Preview</Form.Label>

                                    {typeof getValues("image") == "string" ? (
                                        <div className="image-preview-container">
                                            <img
                                                src={IMG_URL + getValues("image")}
                                                alt="Preview"
                                                className="image-preview"
                                            />
                                        </div>
                                    ) : (
                                        imageFile &&
                                        imageFile?.length > 0 && (
                                            <div className="image-preview-container">
                                                <img
                                                    // src={URL.createObjectURL(getValues("image")[0])}
                                                    src={URL?.createObjectURL(imageFile[0])}
                                                    alt="Preview"
                                                    className="image-preview"
                                                />
                                            </div>
                                        )
                                    )}
                                </div>
                            </Col>

                            <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                    <Link>
                                        <CancelButton
                                            name={"cancel"}
                                            handleClose={props.handleClose}
                                        />
                                    </Link>

                                    <SaveButton
                                        name={"save"}
                                        handleSubmit={handleSubmit(onSubmit)}
                                    />
                                </div>
                            </Row>
                        </Row>
                    </Form>
                </Modal.Body>
            </Modal>

            <ModalSave
                message={showModal.message}
                showErrorModal={showModal.code ? true : false}
            />
        </>
    );
};

export default EditOffCanvance;
